export const workspaceRoles = [
  "owner",
  "admin",
  "developer",
  "approver",
  "viewer",
  "auditor"
] as const;

export type WorkspaceRole = (typeof workspaceRoles)[number];

/** Minimum rank for `requireWorkspaceRole` (higher = more privilege). */
export const workspaceRoleRank: Record<WorkspaceRole, number> = {
  auditor: 1,
  viewer: 1,
  approver: 2,
  developer: 3,
  admin: 4,
  owner: 5
};
